function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import formatStaticUrl from '../utils/formatStaticUrl';
import Media from '../Media';
import StylableSvg from '../StylableSvg'; // Aliases for size

var iconSize = {
  1: 'size-1',
  2: 'size-2',
  3: 'size-3',
  4: 'size-4',
  5: 'size-5',
  6: 'size-6',
  small: 's',
  medium: 'm',
  large: 'l',
  xlarge: 'xl'
};
/**
 * We encode the icon type into the type prop for non svg images so we can use the same
 * usage patterns when serializing displays
 * @param {} type
 */

var resolveType = function resolveType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (type === 'spacer') return {
    format: 'spacer'
  };

  var _slice = (type.match(/^image:(.+)$/) || []).slice(1),
      _slice2 = _slicedToArray(_slice, 1),
      imagePath = _slice2[0];

  var hasExtension = /\.\w{3,4}$/.test(imagePath);

  if (imagePath) {
    return {
      format: 'image',
      path: hasExtension ? imagePath : "".concat(imagePath, ".png")
    };
  }

  return {
    format: 'svg',
    path: type
  };
};
/**
 * The Icon component represents all icons used throughout the UI and represents a
 * true UI primitive. Icons are asynchronously loaded from static.playstation.com by default
 * but is configurable
 *
 * ## Configuration
 *
 * ## Browser usage
 *
 * ```javascript
 * Icon.configure({
 *    url: 'https://static.{envExceptNp}.playstation.com/icons/{version}/',
 *    npEnvironment: 'e1-np',
 *    version: '0.2.2',
 * })
 * ```
 *
 * ### SSR
 *
 * The default SSR support is basic and will not result in svg icons being displayable
 * immediately upon browser rendering the SSR'd page. To configure basic SSR usage in your
 * SSR entrypoint configure the Icon compoonent with:
 *
 * ```javascript
 * Icon.configure({
 *    isSsr: true
 * })
 * ```
 * To get SVG icons to display after SSR you must use the loadIconSsr strategy. See section below
 *
 * #### Custom loader
 *
 * ```javascript
 * import { loadIconSsr } from '@sie/web-common-react-components/server';
 *
 * // strategy for loading svg symbols server side leveraging webpack raw-loader
 * Icon.load = loadIconSsr(type => require(`@sie/web-common-icons/dist/${type}.svg`));
 * ```
 *
 * ## Usage
 *
 * ```jsx
 * <Icon
 *   type="search"
 *   size="small"
 * />
 * ```
 * Image Icon (static.playstation.com hosted images only)
 *
 * ```jsx
 * <Icon
 *   type="image:ps-plus"
 *   size="small"
 * />
 * ```
 *
 * ## Props
 */


var Icon = /*#__PURE__*/function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          size = _this$props.size,
          type = _this$props.type,
          label = _this$props.label;
      if (!type) return null;

      var _resolveType = resolveType(type),
          format = _resolveType.format,
          path = _resolveType.path;

      var _Icon$getClassName = Icon.getClassName({
        className: className,
        size: size,
        type: path
      }),
          root = _Icon$getClassName.root;

      if (format === 'spacer') {
        return /*#__PURE__*/React.createElement("span", {
          className: root
        });
      }

      if (format === 'image') {
        return /*#__PURE__*/React.createElement(Media, {
          qa: qa,
          className: root,
          aspectRatio: "1:1",
          type: "image",
          src: path,
          alt: label,
          useStatic: true
        });
      }

      return /*#__PURE__*/React.createElement(StylableSvg, {
        qa: qa,
        label: label,
        className: root,
        namespace: "ps-icon",
        type: type
      });
    }
  }], [{
    key: "load",

    /**
     * Icon loading strategy. The default is set up to asynchronously load icons from static.
     * playstation.com. To load icons from disk use loadSvgSsr or you can override this function
     * to implement your own strategy.
     *
     * @param {string} type the type of icon to load (e.g. ps-store)
     * @param {Object} options
     * @param {string} [options.namespace='ps-icon'] the namespace of the svg icon
     * @param {string} [options.label] the title text to use for the icon
     * @param {Object} options.config the Icon configuration
     * @returns {ReactNode} the async icon markup
     */
    get: function get() {
      return StylableSvg.load;
    },
    set: function set(loadStrategyFn) {
      StylableSvg.load = loadStrategyFn;
    }
  }]);

  return Icon;
}(PureComponent);

var cx = classNamesFor(Icon);
Icon.resetPalette = StylableSvg.resetPalette;
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Icon
 */

Icon.getClassName = function (_ref) {
  var className = _ref.className,
      type = _ref.type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size;
  return {
    root: cx('psw-icon', size === 'auto' ? 'psw-fill' : "psw-icon-".concat(iconSize[size] || size), _defineProperty({}, "psw-icon--".concat(type), type), className)
  };
};
/**
 * Defines aliases for classNames used by this component
 */


Icon.useClassNames = function (classNames) {
  Icon.classNames = classNames;
};

Icon.config = {
  url: 'https://static.{envExceptNp}.playstation.com/icons/{version}/',
  npEnvironment: 'e1-np',
  version: 'v0',
  isSsr: (typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object'
};

Icon.configure = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.assign(Icon.config, config);
  StylableSvg.configure({
    url: {
      'ps-icon': formatStaticUrl(Icon.config)
    }
  });
};

Icon.defaultProps = {
  qa: '',
  className: '',
  size: '2',
  label: ''
};
Icon.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The size of the icon to use
   */
  size: PropTypes.oneOf(['1', '2', '3', '4', '5', '6', 'auto', // The following  values will be deprecated in the next major version (v1)
  'xs', 's', 'm', 'l', 'xl', 'small', 'medium', 'large']),

  /**
   * Which icon to load (see ui sandbox for assortment)
   */
  type: PropTypes.string.isRequired,

  /**
   * Give the icon a label for screen readers to read
   */
  label: PropTypes.string
};
export default Icon;